import config from "config/config";
import type { ParsedUrlQuery } from "querystring";
import type { ISbRichtext } from "storyblok-js-client";

export const replaceValueInObjectByKey = (obj: ISbRichtext, keyToFind: string, newValue: string): ISbRichtext => {
  const tempObj = obj;
  if (Array.isArray(tempObj)) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < tempObj.length; i++) {
      tempObj[i] = replaceValueInObjectByKey(tempObj[i], keyToFind, newValue);
    }
  } else if (typeof tempObj === "object") {
    // eslint-disable-next-line no-restricted-syntax
    for (const prop in tempObj) {
      if (prop === keyToFind) {
        tempObj[prop] = newValue;
      } else {
        tempObj[prop] = replaceValueInObjectByKey(tempObj[prop], keyToFind, newValue);
      }
    }
  }
  return tempObj;
};

export const updateContent = (planType: string, query: ParsedUrlQuery, content: ISbRichtext): ISbRichtext => {
  if (!query.source) return content;
  const url = `${config.ahplusUrl}/memberships/buy?channel=${query.source}_${planType}`;
  return replaceValueInObjectByKey(content, "url", url);
};
